import { render, staticRenderFns } from "./CourseEvaluationReport.vue?vue&type=template&id=5341a7a0&scoped=true&"
import script from "./CourseEvaluationReport.vue?vue&type=script&lang=js&"
export * from "./CourseEvaluationReport.vue?vue&type=script&lang=js&"
import style0 from "./CourseEvaluationReport.vue?vue&type=style&index=0&id=5341a7a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341a7a0",
  null
  
)

export default component.exports